import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { TicketServiceSelectors } from '../services/ticket-service/state/ticket-service.selectors';
import { RootState } from '../state/state';

@Injectable({
  providedIn: 'root',
})
export class TicketDetailsGuard {
  private readonly store = inject<Store<RootState>>(Store);

  /**
   * Do not allow access to the manual-association routes if there are no selected tickets in the store
   */
  canActivate(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.store.select(TicketServiceSelectors.getSelectedTicketSearchResultCount).pipe(
      // take the first result emitted and kill the subscription, this prevents memory leaks as this method is called multiple times
      take(1),
      map((result) => !!result)
    );
  }
}
